var inventory_location_order_quantity_detail = {}; // Local storage

/* ---------------------------- INVENTORY STUFF ----------------------------- */
function toggle_inventory_order_form_for(item_id){
	GUI.blind_toggle('hidden_form_for_item_'+item_id, 'order_button_'+item_id);
	loadLazyImage('inventoryImg'+item_id);
	return false;
}

function toggle_inventory_received_form_for(order_id) {
	GUI.blind_toggle('hidden_form_for_order_'+order_id, 'received_button_'+order_id, {duration: 0.5});
	var causing_element = $('received_button_'+order_id);
	var target_element = $('hidden_form_for_order_'+order_id);
	if (causing_element.hasClassName('close')) {
		target_element.up('tr').addClassName('bbotgrey');
		causing_element.up('tr').addClassName('bbotwhite');
	} else {
		target_element.up('tr').removeClassName('bbotgrey');
		causing_element.up('tr').removeClassName('bbotwhite');
	}

	return false;
}
function print_inventory_order_form_for(order_id){
	var clone = $($('email_preview_'+order_id).cloneNode(true)); 
	clone.down("input[name=contact_name]").replace( 
		new Element('span').update(clone.down("input[name=contact_name]").value
		)
	);
	clone.down("textarea[name=additional_comments]").replace( 
		new Element('p').update(clone.down("textarea[name=additional_comments]").value
		)
	);
	var newWindow=window.open('','Allmoxy Printable Supply Order')
	newWindow.document.write(clone.innerHTML)
	newWindow.focus();
	newWindow.print();
}


function update_supply_order_info(iteration, orderingInfo){
	$('contact_name_'+iteration).value = orderingInfo.contact_name;
	$('contact_email_'+iteration).value = orderingInfo.contact_email;
	$('vendor_company_name_'+iteration).update(orderingInfo.vendor_company_name);
	$('vendor_price_'+iteration).update(orderingInfo.vendor_price);
	$('part_num_'+iteration).update(orderingInfo.part_num);
	$('details_vendor_price_'+iteration).update(orderingInfo.vendor_price);
	$('details_part_num_'+iteration).update(orderingInfo.part_num);
}
function change_process(pro_select){
	var id = pro_select.id.match(/\d+/).pop();
	if($F('worker_'+id) && !$('raw_wages_'+id).innerHTML.blank() && $('raw_wages_'+id).innerHTML.slice(0,2)!='<a')
		return false;	// allow contact's wage to trump process's average wage.
	var wage = pro_select.select("option")[pro_select.selectedIndex].getAttribute('rel');
	jobs_raw_wages(wage,id);
	return false;
}
function jobs_raw_wages(wage_string,labor_id){
	if(wage_string && wage_string != '?'){
		var r = number_format(wage_string,2);
		$('raw_wages_'+labor_id).update(number_format(r,2));
		$('pr_tax_'+labor_id).update(number_format(payrollTaxRate*100));
		$('wages_'+labor_id).value = number_format(r*(1+payrollTaxRate),2);
	} else {
		$('raw_wages_'+labor_id).update('<a style="color:red">NONE</a>');
		$('pr_tax_'+labor_id).update(number_format(payrollTaxRate*100));
		$('wages_'+labor_id).value = '';
	}
	if($F('hours_'+labor_id)) calc_labor(labor_id);
}
// labor functions
function change_labor(contact_id,labor_id){
	var id = parseInt(contact_id);
	if(!id || isNaN(id) || id != contact_id){
		var proc = $('labor_process_'+labor_id);
		jobs_raw_wages(proc&&proc.selectedIndex?(proc.select('option')[proc.selectedIndex]).getAttribute('rel'):'?',labor_id);
		return;
	}
	new Ajax.Request('ajax/', {
		parameters : {'table':'contact_wage', 'contact_id':id},
		onSuccess : function(ret){
			if(ret && ret.responseText) jobs_raw_wages(ret.responseText,labor_id);
		}
	});
	calc_labor();
}
function calc_labor(e){
	if(e !== undefined){
		var id;
		if(e.element)
			id = e.element().id.match(/\d+/).pop();
		else
			id = e;
		if(id !== undefined){
			var wages = cur2num($('raw_wages_'+id).innerHTML) * (1+payrollTaxRate);
			if(wages){
				var labor = $('labor_'+id);
				if(labor){
					var hours = cur2num($F('hours_'+id)) || 0;
					labor.update(get_currency_symbol()+number_format(hours*wages,2));
				}
			}
		}
	}
	var sum = 0;
	$$('.labor_cost').each(function(o){
		if(o.innerHTML)
			sum += cur2num(o.innerHTML.replace(/[\$\,]/g,'')); 
	});
	$('labor_total').update(get_currency_symbol()+number_format(sum, 2));
	var sum = 0;
	$$('.hours').each(function(o){
		if($F(o))
			sum += cur2num($F(o).replace(/[\$\,]/g,'')); 
	});
	$('man_hours').update(number_format(sum, 3));
	var proportion = sum/totalHours;
	update_overhead_percent(proportion);
	$$('#overhead tbody input.default').each(function(o){
		o.value = number_format(proportion*100,2)
		var oid = o.id.match(/\d+$/).pop();
		$('overhead_total_'+oid).update(number_format(cur2num($('overhead_cost_'+oid).innerHTML)*proportion,2));
	});
	update_overhead();
	if(e !== undefined){
		theOrder.process();
	}
}
function update_overhead_percent(prop){
	var rounded = number_format(prop*100,2);
	$('overhead_percent').update(rounded);
	$('overhead_percent').setAttribute('rel',prop);
	$('overhead').select('input').each(function(percent){
		if(percent.hasClassName('default'))
			percent.value = rounded;
		else if(percent.value == rounded)
			percent.addClassName('default');
		percent.setAttribute('default_value',rounded);
	});
}
function populate_item_data(data,il) {
	if (data) {
		if($('piece_size_'+il)){
			$('piece_size_'+il).update(data.piece_size);
		}
		if($('price_'+il)){
			var show_price = data.price?CurrencyFormatted(data.price):'N/A';
			$('price_'+il).update(show_price);
		}
		if($('on_hand_'+il)){
			$('on_hand_'+il).update(data.quantity);
		}
		if ($('available_'+il)) {
			$('available_'+il).update(data.available);
		}
		if($('inv_info')){
			if($('order_id'))
				reset_order_info();
			$('inv_info').update('Qty on Hand: <span id="inv_qty">'+data.quantity+'</span>, Piece Size: '+data.piece_size);
			$('checkout_photo').src = data.picture_filename?'data/inv/'+data.picture_filename:'https://cdn.allmoxy.com/mrp/images/default_inv.png';
			$('checkout_photo').setAttribute('alt',data.name);
		}
	} else clear_item_data(il);
	change_qty(il);
}

function populate_moving_item_data(data, il)
{
	if(data)
	{
		if($('inv_info'))
		{
			if($('order_id'))
				reset_order_info();

			var from_data, to_data;
			if(data[0].from_to === 'from')
			{
				from_data = data[0];
				if(data[1])
					to_data = data[1];
			}
			else
			{
				if(data[1])
					from_data = data[1];
				to_data = data[0];
			}

			$('inv_info').update(
				'<table class="checkin_table"><tbody>' +
				'<tr><td>Qty on Hand:</td><td>' +
				(from_data ? ('<span id="from_inv_qty">' + from_data.quantity + '</span> (' + from_data.location_name + ')<br/>') : '') +
				(to_data ? ('<span id="to_inv_qty">' + to_data.quantity + '</span> (' + to_data.location_name + ')<br/>') : '') +
				'</td></tr>' +
				'<tr><td>Piece Size:</td><td>' + data[0].piece_size + '</td></tr>' +
				'</tbody></table>'
			);
			const photo = $$('#checkout_photo')
			const leftColumn = $$('#am_left_column');
			const rightColumn = $$('#am_right_column');
			if(data[0].picture_filename){
				photo[0].src = `data/inv/${data[0].picture_filename}`;
				photo[0].setAttribute('alt', data[0].item_name);	
				leftColumn[0].removeClassName("no_photo");
				rightColumn[0].removeClassName("nophoto");
			}else{
				leftColumn[0].addClassName("no_photo");
			}

			if(!$('move_supply_gui').checked)
				$('track_to_an_order').checked = Boolean(Number(data[0].associate_to_orders)); //get "0" to 0 then to false
			observe_track_to_an_order();
			$('il_0').setAttribute('data-track_to_an_order', data[0].associate_to_orders);
		}
	}
	else
		clear_item_data(il);
	change_qty(il);
}

function toggle_move_supply_gui(element)
{
	$('location_0').up().down('label').update($(element).checked ? 'From Location:' : 'Location:');
	$('to_location_row').toggle();
	$$('a.check_in')[0].toggle();
	$$('a.check_out')[0].toggle();
	$$('a.move_supply')[0].toggle();

	if($(element).checked)
	{
		$('track_to_an_order_div').hide();
		$('track_to_an_order').checked = false;
	}
	else
	{
		$('track_to_an_order_div').show();
		$('track_to_an_order').checked = Boolean(Number($('il_0').getAttribute('data-track_to_an_order')));
	}
	observe_track_to_an_order();
	$('to_location_0').value = '';
}

function clear_item_data(il){
	['piece_size_','quantity_','price_','cost_'].each(function(o){
		var ob = $(o+il);
		if(ob) ob.update('');
	});
	if($('checkout_photo')){
		$('checkout_photo').src = 'https://cdn.allmoxy.com/mrp/images/default_inv.png';
		$('checkout_photo').alt = '';
	}
	if($('inv_info')) $('inv_info').update('');
}
function change_qty(e){
	if(e !== undefined){
		var il;
		if(e.element)
			il = e.element().id.match(/\d+/).pop();
		else
			il = e;
		if(il !== undefined){
			var price = $('price_'+il);
			if(!price) return;
			price = price.innerHTML.replace(/[\$\,]/g,'');
			if(price == 'N/A') return;
			var qty = cur2num($F('quantity_'+il)) || 0;
			if(isNaN(qty)) return;
			var cost = $('cost_'+il);
			if(!cost) return;
			cost.update(get_currency_symbol()+number_format(qty*price,2));
		}
	}
	var sum = 0;
	$$('.item_cost').each(function(o){
		if(o.innerHTML != 'N/A' && !o.innerHTML.blank())
			sum += cur2num(o.innerHTML.replace(/[\$\,]/g,''));
	});
	$('item_total').update(get_currency_symbol()+number_format(sum,2));
	if (e !== undefined)
		theOrder.process();
	//order.pricing();
}
function overhead_onblur(ob, noProcess){
	ob.value=number_format(cur2num($F(ob)),2);
	if($F(ob).blank() || cur2num($F(ob)) == cur2num($('overhead_percent').innerHTML)){
		ob.addClassName('default');
		ob.value = $('overhead_percent').innerHTML;
	} else {
		ob.removeClassName('default');
	}
	var obj = {};
	obj['element'] = function(){ return ob; };
	update_overhead(obj, noProcess);
}
function update_overhead(e, noProcess){
	if(e !== undefined){
		var ob, id;
		if(e.element){
			ob = e.element();
			id = ob.id.match(/\d+/).pop();
		} else {
			id = e;
			ob = $('overhead_'+id);		
		}
		if(ob){
			var cost = $('overhead_cost_'+id), prop;
			if($('overhead_'+id).hasClassName('default'))
				prop = $('overhead_percent').getAttribute('rel');
			else
				prop = cur2num($F(ob))/100;
			$('overhead_total_'+id).update(number_format(prop*cur2num($('overhead_cost_'+id).innerHTML),2));
		}
	}
	var sum = 0;
	$$('.overhead_total').each(function(o){
		var oid = o.id.match(/\d+$/).pop();
		if(o.innerHTML != 'N/A' && !o.innerHTML.blank())
			sum += cur2num(o.innerHTML.replace(/[\$\,]/g,''));
	});
	$('overhead_total').update(get_currency_symbol()+number_format(sum,2));
	if (e !== undefined && !noProcess)
		theOrder.process();
	//order.pricing();
}
function update_cost(e){
	var sum = 0;
	$$('.costs').each(function(o){
		if($F(o))
			sum += cur2num($F(o));
	});
	$('costs_total').update(get_currency_symbol()+number_format(sum,2));
	if (e !== undefined)
		theOrder.process();
	//order.pricing();
}
function remove_labor_row(obj) {
	obj.up('tr').remove();
	calc_labor();
	return false;
}
function remove_supply_row(obj) {
	obj.up('tr').remove();
	change_qty();
	return false;
}
function remove_cost_row(obj) {
	obj.up('tr').remove();
	update_cost();
	return false;
}
function cur2num(inp){
	if (inp == null) return 0;
	var s = inp.toString().replace(/<[^>]*>/g, '');
	return Number(s.replace(/[^0-9\.-]+/g,'')) || 0;
}
function number_format(num,prec){
	if(typeof(num)=='string') num = num.replace(',', '', 'g'); 
	if(prec !== null && prec !== undefined) num = precision(num,prec);
	var arr = num.toString().split('.');
	var whole = arr[0];
	var frac = arr[1];
	whole = parseInt(whole) || 0;
	whole += ' ';
	var old;
	while(old != whole){
		old = whole;
		whole = whole.replace(/(\d)(\d{3})(\D)/g,'$1,$2$3');
	};
	whole = whole.replace(/\ $/,'');
	if(num < 0 && whole == 0) whole = '-0';
	return whole+(frac?'.'+frac:'');
}
function precision(o,pow){
  var val = Math.pow(10, pow || 0);
  o = (parseInt(Math.round(o*val))/val).toString();
  if(o.match(/\..+/)){
	while(o.match(/\..+/).pop().length<=pow){
	  o+='0';
	}
  } else if(pow > 0){
  	o+='.';
  	while(pow-- > 0){
  		o+='0';
  	}
  }
  return o;
}

/**** THE ABOVE AND BELOW FUNCTIONS SHOULD BE COMBINED INTO ONE GENERALIZED FORM. I'LL DO IT. -cbp ****/

function reset_order_info(){
	$('order_id').value = $('order').value = '';
	if($('order_info'))
		$('order_info').update('');
}

var vendorcount;
var new_vendor_html = 'purposly blank';
function addVendor() {
	vendorcount = new Date().getTime()+parseInt(Math.random()*1000);
	$('vendors_tbody').insert(new_vendor_html.replace(/undefined/g,vendorcount));
}

var new_location_html = 'purposly blank';
var locationcount;
function addLocation(){
	locationcount = new Date().getTime()+parseInt(Math.random()*1000);
	$('locations_tbody').insert(new_location_html.replace(/undefined/g,locationcount));
}

function mark_preferred_vendor(el){
	$$('.preferred').invoke('removeClassName', 'preferred');
	el.up('tr').addClassName('preferred'); // Changes styles on "view" page but not "edit" page; we should make the row background green or something
}
function populate_and_submit(e){
	if(!e.element) return false;	// only accept events
	pick_clock(e.element().up(),true);
	submit_time(e.element());
}
function submit_time(mox, ajaxy) {
	ajaxy = ajaxy===false?false:true;
	var button_id = mox.id;
	mox = mox.up('form').mox;
	mox.failed = false;
	mox.require('contact_id','Choose an employee.');
	var order = $F('track_order');
	if(!order.blank() && order.match(/^#?(\d+)(.*)$/)) {
		$('track_order_id').value = order.match(/^#?(\d+)(.*)$/)[1];
		//order_status_not_shipped(order.substr(1, order.length));
	}
	var shipping = $('shipping_alert').value;
	var state = true;
	if($('order_status').value == 'shipped' && shipping!=1){
		$('shipping_alert').value = 1;
		state = false;
	}
	mox.validate(state, 'order_status', "This order has been marked shipped. Tracking time to this order could cause it to be moved out of shipped status.");
	
	var inval_msg = get_language_translation('LANG_INVALID_ORDER_NUMBER') + '.';
	var chooseProcess_msg = get_language_translation('LANG_CHOOSE_A_PROCESS') + '.';
	var track_order = $('track_order');
	if(track_order.getAttribute('data-was_clicked') == 'false'){
		// Typed but never picked from the dropdown / a tab row (flag is set by
		// time_tracking_job_update): stops invalid order ids from being used and breaking time tracking.
		track_order.value = '';
		mox.require('track_order', inval_msg);
	}
	mox.require('track_order_id', inval_msg);
	mox.require('process', chooseProcess_msg);
	if(!mox.failed){
		if(ajaxy){
			if(time_tracking_init.periodic_updater) clearTimeout(time_tracking_init.periodic_updater);
			var params = {'table':'submit_time','action':button_id}, ids = [];
			$('time_tracking').select('input,select').each(function(o){
				if(!o.name.blank() && !o.hasClassName('default')){
					params[o.name] = $F(o);
					ids.push(o);
				}
			});
			new Ajax.Request('ajax/', {
				parameters : params,
				onSuccess : function(ret){
					if ($('MB_caption')) $('MB_caption').setStyle({'backgroundColor':'#080'});
					$('recent_clocks').update(ret.responseText);
//					tab_select($('rec_tab'));
//					$('employee_clocks').update("<tr><th colspan='4'>Choose an Employee</th></tr>");
//					$('job_clocks').update("<tr><th colspan='4'>Choose an Order</th></tr>");
					ids.each(function(o){
						if(o.tagName.toLowerCase()=='select')
							o.selectedIndex = 0;
						else if (!(o.name == 'unformatted_track_date' || o.name == 'track_date_sql' || o.name == 'employee' || o.name == 'contact_id'))
							o.value = '';
					});
					var dates = formatDate($F('track_date'));
					$('track_date_sql').value = dates[1];
					$('MB_caption').setStyle({'backgroundColor':''});
					time_tracking_init.periodic_updater = setTimeout(time_tracking_update_recent, 900000);
				}
			});
		} else {
			$('time_tracking').submit();
		}
	}
	return false;
}

function submit_employee_time(mox, ajaxy) {
	ajaxy = ajaxy===false?false:true;
	var button_id = mox.id,
		action = mox.up('form').action;
	mox = mox.up('form').mox;
	mox.failed = false;
	mox.require('contact_id','Choose an employee.');
	var order = $F('track_order');
	if(!order.blank() && order.match(/^#?\d+$/))
		$('track_order_id').value = order.slice(0,1)=='#'?order.slice(1):order;

	var inval_msg = get_language_translation('LANG_INVALID_JOB_NUMBER') + '.';
	var chooseProcess_msg = get_language_translation('LANG_CHOOSE_A_PROCESS') + '.';
	mox.require('track_order_id', inval_msg);
	mox.require('process', chooseProcess_msg);
	if(!mox.failed){
		if(ajaxy){
			var params = {'table':'submit_time','action':button_id}, ids = [];
			$('edit_employee_time_clock').select('input,select').each(function(o){
				if(!o.name.blank() && !o.hasClassName('default')){
					params[o.name] = $F(o);
					ids.push(o);
				}
			});
			new Ajax.Request(action, {
				parameters : params,
				onSuccess : function(ret){
					var new_amount = $('track_hours').value;
					$('MB_caption').setStyle({'backgroundColor':'#080'});
					ids.each(function(o){
						if(o.tagName.toLowerCase()=='select')
							o.selectedIndex = 0;
						else
							o.value = '';
					});
					var dates = formatDate($F('track_date'));
					$('track_date_sql').value = dates[1];
					$('MB_caption').setStyle({'backgroundColor':''});
					Modalbox.hide();
					if($('employee_time_tracking'))
						tableAutoUpdate('employee_time_tracking');

					if($('time_tracking'))
						tableAutoUpdate('time_tracking');

					if(new_amount != $('track_hours').getAttribute('data-amount'))
						$$('tr[data-timeclock_id=' + $('edit_employee_time_clock').getAttribute('data-timeclock_id') + '] td.timeclock_amount')[0].innerHTML = new_amount;
				}
			});
		} else {
			$('edit_employee_time_clock').submit();
		}
	}
	return false;
}
function ajax_submit(form, where, none_element){
	var data = {};
	form.getElements().each(function(i){
		switch(i.getAttribute('type')){
			case 'input':
			case 'textarea':
			case 'select':
			case 'submit':
				data[i.name] = $F(i);
				break;
			case 'checkbox':
				if(i.checked)
					data[i.name] = $F(i) || true;
				break;
			case 'radio':
				if(data[i.name])
					data[i.name] = $F(i);
				else
					data[i.name] += ',' + $F(i);
				break;
		}
		if('button'!=i.getAttribute('type'))
			data[i.name] = $F(i);
	});
	delete(data['']);
	var act = form.action.replace(/\/+$/,'')+'/';	// ensure a single trailing slash
	var act_arr = act.split('/');
	data['table'] = act_arr[0];
	if(act_arr[1]) data['action'] = act_arr[1];
	new Ajax.Request(act, {
		parameters : data,
		onSuccess : function(ret){
			if($(none_element)){
				$(none_element).remove();
			}
			where.insert( ret.responseText );
			form.down('textarea').value = '';
		}
	});
	return false;
}
function pick_clock(e, no_tabs){
	var ob = e.element?e.element():e;
	if(ob.tagName.toLowerCase() == 'a')
		return;
	var tr = ob.up('tr');
	if($('track_hours')) $('track_hours').value = '';
	switch(ob.up('div').id){
		case 'emp_div':
			selectByValue($('process'), tr.childElements()[2].getAttribute('rel'));
			var job = tr.childElements()[3];
			var id = job.getAttribute('rel');
			$('track_order_id').value = id;
			$('track_order').value = job.innerHTML + ', ' + job.getAttribute('alt').replace('&lsquo;',"'");
			time_tracking_job_update(id, function(ret){
				if(ret.responseText) $('job_clocks').update(ret.responseText);
				if(!no_tabs) tab_select($('job_tab'));
				track_button();
			});
			break;
		case 'job_div':
			selectByValue($('process'), tr.childElements()[3].getAttribute('rel'));
			var a = tr.childElements()[2];
			var id = a.getAttribute('rel');
			$('contact_id').value = id;
			$('employee').value = a.innerHTML;
			time_tracking_employee_update(id, function(ret){
				if(ret.responseText) $('employee_clocks').update(ret.responseText);
				if(!no_tabs) tab_select($('emp_tab'));
				track_button();
			});
			break;
		case 'rec_div':
			selectByValue($('process'), tr.childElements()[2].getAttribute('rel'));
			var job = tr.childElements()[3];
			var id = job.getAttribute('rel');
			$('track_order_id').value = id;
			$('track_order').value = job.innerHTML + ', ' + (job.getAttribute('alt')?job.getAttribute('alt').replace('&lsquo;',"'"):'');
			time_tracking_job_update(id, function(ret){
				if(ret.responseText) $('job_clocks').update(ret.responseText);
			})
			var emp = tr.childElements()[1];
			var id = emp.getAttribute('rel');
			$('contact_id').value = id;
			$('employee').value = emp.innerHTML;
			time_tracking_employee_update(id, function(ret){
				if(ret.responseText) $('employee_clocks').update(ret.responseText);
				if(!no_tabs){
					if(ob.innerHTML.slice(0,1)=='#'){
						tab_select($('job_tab'));
					} else {
						tab_select($('emp_tab'));
					}
				}
				track_button();
			})
			break;
	}
}
function track_button(st){
	return;
/*
	if(!st){
		var is_open = false, cid = $F('contact_id'), jid = $F('track_order_id'), pid = $F('process');
		if($('track_hours') && Number($F('track_hours'))) is_open = true;
		if(cid && jid && pid && !is_open){
			$('emp_div').select('tbody tr').each(function(tr){
				if(tr.down('a') && tr.down('a').getAttribute('style')){		// if open clock
					if(jid == tr.childElements()[2].getAttribute('rel') &&
						pid == tr.childElements()[1].getAttribute('rel')
					){
						is_open = true;
						throw $break;
					}
				}
			});
			if(!is_open){	// if it's found, why continue looking?
				$('job_div').select('tbody tr').each(function(tr){
					if(tr.down('a') && tr.down('a').getAttribute('style')){		// if open clock
						if(cid == tr.childElements()[1].getAttribute('rel') &&
							pid == tr.childElements()[2].getAttribute('rel')
						){
							is_open = true;
							throw $break;
						}
					}
				});
			}
		}
		if(is_open)
			$('startstop').removeClassName('timeclock_start').addClassName('timeclock_stop').update('<span><span></span>Stop</span>');
		else
			$('startstop').removeClassName('timeclock_stop').addClassName('timeclock_start').update('<span><span></span>Start</span>');
	} else {
		if('.'!=st && $F('track_order_id') && $F('contact_id') && $F('process'))
			$('startstop').removeClassName('timeclock_start').addClassName('timeclock_stop').update('<span><span></span>Stop</span>');
		else
			$('startstop').removeClassName('timeclock_stop').addClassName('timeclock_start').update('<span><span></span>Start</span>');
	}
*/
}
function selectByValue(sel, val){
	var tar = 0;
	sel.select('option').each(function(o,i){
		if(o.value == val){
			tar = i;
			return;
		}
	});
	sel.selectedIndex = tar;
}
function time_tracking_init(){
	if(!$('time_tracking')) return;
//	Event.stopObserving(document,'modal:open');
//	if(time_tracking_init.arr)
//		time_tracking_init.arr.each(function(e){ e.remove_event_listeners(); });
	
	// ugly clock images delegation hassle
	var container = $('time_tracking').select('.tab_box')[0]; 
	container.stopDelegating('tbody td', 'click', pick_clock);
	container.stopDelegating('tbody a', 'click', populate_and_submit);
	container.delegate('tbody td', 'click', pick_clock);
	container.delegate('tbody a', 'click', populate_and_submit);
	
	// ugly removable autocompleters hassle
	time_tracking_init.arr = [];
	time_tracking_init.arr.push(new Ajax.Autocompleter('employee', "autocomplete_employee", "ajax/", {
		parameters: 'table=autocomplete_employee',
		minChars: 2,
		indicator: 'indicator1',
		frequency: 0.4,
		afterUpdateElement: function(textInput, li){
			li.up('ul').hide();	// prevent double-click
			time_tracking_employee_update(li.id.substr(3), function(ret){
				if(ret.responseText) $('employee_clocks').update(ret.responseText);
				tab_select($('emp_tab'));
				track_button();
			});
		}
	}));
	time_tracking_init.arr.push(new Ajax.Autocompleter('track_order', "autocomplete_orders", "ajax/", {
		parameters: 'table=autocomplete_orders',
		minChars: 2,
		indicator: 'indicator2',
		frequency: 0.4,
		afterUpdateElement: function(textInput, li){
			li.up('ul').hide();	// prevent double-click
			time_tracking_job_update(li.id.substr(3), function(ret){
				if(ret.responseText) $('job_clocks').update(ret.responseText);
				tab_select($('job_tab'));
				track_button();
			});
		}
	}));
	time_tracking_init.periodic_updater = setTimeout(time_tracking_update_recent, 900000);
}
function time_tracking_update_recent(){
	if(!$('time_tracking')) return;
	delete time_tracking_init.periodic_updater;
	new Ajax.Request('ajax/', {
		parameters : {
			'table':'submit_time'
		},
		onSuccess : function(ret){
			$('recent_clocks').update(ret.responseText);
			tab_select($('rec_tab'));
			time_tracking_init.periodic_updater = setTimeout(time_tracking_update_recent, 900000);
		}
	});
}
function time_tracking_employee_update(id, callback){
	$('contact_id').value = id;
	 // run another ajax query to get time_tracking for this employee
	new Ajax.Request('ajax/', {
		parameters : {
			'table' : 'employee_tracking',
			'contact_id' : id
		},
		onSuccess : callback
	});
}
function time_tracking_job_update(id, callback){
	// DEV-13144: every legitimate order selection lands here - the autocomplete pick
	// (click or keyboard, via afterUpdateElement) and the employee / recent tab rows
	// (pick_clock). Mark the field as picked-from-a-list HERE, not from a timer bound
	// to the dropdown rows: Ajax.Autocompleter re-renders those rows when its response
	// arrives, so a click handler attached to them earlier was lost whenever the
	// order search took longer than the timer, and submit_time then rejected every
	// order as "Invalid Order Number".
	var track_order = $('track_order');
	if (track_order) track_order.setAttribute('data-was_clicked', 'true');
	order_status_not_shipped(id);
	$('track_order_id').value = id;
	 // run another ajax query to get time_tracking for this employee
	new Ajax.Request('ajax/', {
		parameters : {
			'table' : 'orders_tracking',
			'track_order' : id
		},
		onSuccess : callback
	});
}
var job_clocks_delay = null;
function get_job_clocks(){
	if(job_clocks_delay) clearTimeout(job_clocks_delay);
	job_clocks_delay = setTimeout(job_clocks_ajax, 400);
}
function job_clocks_ajax(){
	new Ajax.Request('ajax/', {
		parameters : {
			'table' : 'orders_tracking',
			'track_order' : $F('track_order_id')
		},
		onSuccess : function(ret){
			if(ret.responseText) $('job_clocks').update(ret.responseText);
		}
	});
}
function tab_select(ob){
	ob.up().select('.selected')[0].removeClassName('selected');
	ob.addClassName('selected');
	ob.up().next('div').select('div').each(function(o){
		o.hide();
	});
	$(ob.getAttribute('rel')).show();
}
//Copies the template copy contact row, and adds it as a new "copy contact" row
//to enable that a task is a assigned to multiple contacts at the same time
function add_contact_to_task(where){
	//Get the template for copy contact selection
	let new_row = $("copy_contact_~id~");
	var num = new Date().getTime() + parseInt(Math.random()*1000);
	//Replace random template with a random id
	var append = new_row.outerHTML.replace(/~id~/g,num);
	var vals = [];
	//Put the new element after the last copied contact
	where.select('select').each(function(o){ vals.push($F(o)); });
	where.innerHTML += append;
	where.select('select').each(function(o){ o.value = vals.shift(); });
	$('copy_contact_'+num).show();
}
function hours2time(hours){
	var hr = parseInt(hours);
	var min = round((hours - hr) * 60);
	if(min.length==1) min = '0'+min;
	return hr+':'+min;
}

function delete_note(note_id){
	if(confirm(get_language_translation('LANG_ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_NOTE'))){
		var note_div = $('note_'+note_id);
		note_div.addClassName('line-through');
		note_div.addClassName('loading');	
		var url = 'notes/delete/'+note_id+'/';
		new Ajax.Request(url, {
			onSuccess: function(transport) {
				note_div.update(transport.responseText);
				note_div.removeClassName('loading');
				note_div.removeClassName('line-through');
				note_div.addClassName('deleted');
				note_div.highlight({ endcolor: hlcolor(note_div), queue: 'end', duration: 1.5 }).blindUp({ 
					queue: 'end', 
					duration: 1.5, 
					afterFinish: function(){
						if($('notes') && $('notes').visible() &&  $('notes').select('.note:not(.deleted)').size() < 1 ){
							//$('notes').blindUp();
						}
					} 
				});
			}, 
			onFailure: function(transport) {
				add_notification(get_language_translation('LANG_MSG_ERROR_DELETING_NOTE_YOU_MAY_NOT_BE_AUTHORIZED_TO_DELETE_THAT_NOTE'), 'danger');
				el.removeClassName('line-through');
				el.removeClassName('loading');
			}
		});
	}
	return false;
}
function job_note_visibility(ob){
	var params = {};
	params['jnote_id'] = ob.id.replace('visibility_','');
	params['visibility'] = $F(ob);
	new Ajax.Request('notes/editjob/', {
		parameters : params
	});
}
function order_mark_preferred(ob){
	ob = $(ob);
	var pref = ob.up('tbody').down('.preferred');
	if(pref) pref.removeClassName('preferred');
	var tr = ob.up('tr').addClassName('preferred');
	tr.down('input').checked = true;
}


function employee_time_tracking_init() {

//        if(employee_time_tracking_init.arr)
//        	employee_time_tracking_init.arr.each(function(e){ e.remove_event_listeners(); });
//
//        // ugly removable autocompleters hassle
//        employee_time_tracking_init.arr = [];
//        employee_time_tracking_init.arr.push();

	new Ajax.Autocompleter('track_order', "autocomplete_orders", "ajax/", {
		parameters:'table=autocomplete_orders',
		minChars:2,
		indicator:'indicator2',
		frequency:0.4,
		afterUpdateElement:function (textInput, li) {
			li.up('ul').hide();	// prevent double-click
			time_tracking_job_update(li.id.substr(3), function (ret) {
				//if (ret.responseText) $('job_clocks').update(ret.responseText);
				//                    tab_select($('job_tab'));
				//                    track_button();
			});
		}
	});
}
//PO functions
function move_row(el, vendor_id) {
	if (!vendor_id) var vendor_id = el.value;
	var row = $(el).up("tr");
	var fieldset = row.up("fieldset");
	if (!fieldset || !fieldset.id || fieldset.id.indexOf("vendor_") !== 0) {
		recalculate_po_totals();
		return;
	}

	var old_vendor_id = fieldset.id.replace("vendor_", "");
	if (vendor_id == old_vendor_id) {
		recalculate_po_totals();
		return;
	}

	var vendor_sel = row.down("select");
	vendor_sel.value = vendor_id;
	vendor_sel.select("option").each(function (opt) {
		opt.removeAttribute("selected");
	});
	vendor_sel
		.select("option")
		[vendor_sel.selectedIndex].writeAttribute("selected", "selected");

	new Ajax.Request("ajax/supplies/get_vendor_info/", {
		parameters: {
			vendor_id: vendor_id,
			item_id: el.readAttribute("data-item_id"),
		},
		onSuccess: function (ret) {
			var target_fieldset = $("vendor_" + vendor_id);
			if (!target_fieldset) {
				var vendor = vendor_template.evaluate({
					id: vendor_id,
					name: ret.responseJSON.vendor_company_name,
					email: ret.responseJSON.contact_email,
					pname: ret.responseJSON.contact_name,
				});
				$("pos").insert(vendor);
				target_fieldset = $("vendor_" + vendor_id);
			}

			var old_tbody = fieldset.down("tbody");
			var validation_row = null;
			if (row && row.next) {
				var next_row = row.next();
				if (next_row && next_row.hasClassName("validation-advice-row")) {
					validation_row = next_row;
				}
			}

			row.remove();
			if (validation_row) {
				validation_row.remove();
			}
			if (target_fieldset && target_fieldset.down("table tbody")) {
				target_fieldset.down("table tbody").insert(row);
				if (validation_row) {
					target_fieldset.down("table tbody").insert(validation_row);
				}
				target_fieldset.show();
			}

			if (old_tbody && old_tbody.select("tr").length === 0) {
				fieldset.remove();
			}

			sort_po();
			checkPOItems();
			recalculate_po_totals();
		},
		onFailure: function (ret) {
			recalculate_po_totals();
		},
	});
}
function check_visible(el) {
	if ($(el).select('tr').length == 1)
		$(el).up('fieldset').hide();
	return false;
}
function sort_po() {
	var pos = $('pos').clone(true);
	var sorted_pos = pos.select('fieldset').sort(function(a,b) { var str1 = a.down('h1').innerHTML; var str2 = b.down('h1').innerHTML; return ( str1 == str2 ) ? 0 : ( ( str1 > str2 ) ? 1 : -1 ); });
	$('pos').update();
	sorted_pos.each(function(po) { $('pos').insert(po); });
}
function send_email(el) {
	var show = el.checked;
	var fieldset = el.up('fieldset');
	var sections = fieldset.select('.email_section');

	if (show) {
		sections.invoke('show');
	} else {
		sections.invoke('hide');
	}

	toggleEmailValidation(fieldset, show);
}

function toggleEmailValidation(fieldset, show) {
	var inputs = fieldset.select('.email_section input');
	if (inputs.length === 0) return;

	inputs.each(function(input) {
		// Only the address fields get email validation. The old version marked
		// EVERY input in the section required + validate-email — subject lines
		// and contact names can never match an email regex, so any vendor with
		// send-email on could never pass validation and no PO was ever created
		// (DEV-12475). Email is required; reply-to validates only when filled
		// (the controller falls back to the current user when it's blank).
		var name = input.readAttribute('name') || '';
		var isEmail = name.indexOf('email[') === 0;
		var isReplyTo = name.indexOf('reply_to[') === 0;
		if (show && isEmail) {
			input.addClassName('required');
			input.addClassName('validate-email');
		} else if (show && isReplyTo) {
			input.removeClassName('required');
			input.addClassName('validate-email');
		} else {
			input.removeClassName('required');
			input.removeClassName('validate-email');
		}
	});
}


function build_select(name,id,opts,extra_params) {
	var sel = new Element('select',{ 'name':name,'id':id });
	if (opts) {
		if (opts.constructor.name == 'Object') opts = $H(opts);
		opts.each(function (group) {
			if (group.constructor.name == 'Array') {
				var og = new Element('optgroup',{label: group.key});
				group.value.each(function(opt) {
					// value is trimmed due to some values have \r or \n
					var op = new Element('option',{ 'value':opt.id.trim() }).update(opt.value);
					if (extra_params) {
						extra_params.each(function(param) {
							op.writeAttribute(param.key, opt[param.value]);
						});
					}
					og.insert(op);
					//alert(opt.value);	
				});
				sel.insert(og);
			}
			else {
				// value is trimmed due to some values have \r or \n
				var op = new Element('option',{ 'value':group.id.trim() }).update(group.value);
				if (extra_params) {
					extra_params.each(function(param) {
						op.writeAttribute(param.key, group[param.value]);
					});
				}
				sel.insert(op);
			}
		});
	}

	if(id.includes('address_cp') || id.includes('address_ct')){ // old create account form validation requires this attribute
		sel.setAttribute('data-is_valid', false);
	}
	return sel;
}
function get_items(el) {
	new Ajax.Request('ajax/supplies/get_items/', {
		parameters : { 'location_id':el.value },
		onSuccess : function(ret){
			var itemsel = build_select('items','items',ret.responseJSON.items,$H({ 'data-il_id':'il_id' }));
			$('items').replace(itemsel);
			am.$('#editItemButton').hide();
			if (!ret.responseJSON.items || !ret.responseJSON.items.length) {
				itemsel.insert(new Element('option', { 'value': '' }).update('--No Items Found--'));
				itemsel.disable();
				$('vendors').disable();
			}
			else {
				itemsel.observe('change',get_vendors);
			}
			get_vendors();
			var editurl = '/inventory/edit/' + am.$('#items').val();
			am.$('#editItemButton').attr('href', editurl);
		}
	});
}

function get_order_quantity_by_item_and_location_id() {
	if (
		am.$('#order_qty_value').length > 0 && am.$('#location_1').length > 0 && am.$('#items').length > 0
	) {
		const item_id = am.$('#items')[0].value;
		const location_id = am.$('#location_1')[0].value;
		const dynamic_key = 'item_id_' + item_id + '_location_id_' + location_id;
		if (inventory_location_order_quantity_detail.hasOwnProperty(dynamic_key)) {
			am.$('#order_qty_value').text(inventory_location_order_quantity_detail[dynamic_key]);
			return;
		}

		new Ajax.Request("ajax/supplies/get_order_quantity_by_item_and_location_id/", {
			parameters: {
				location_id: am.$('#location_1')[0].value,
				item_id: am.$('#items')[0].value
			},
			onSuccess: function (ret) {
				am.$('#order_qty_value').text(ret.responseJSON.order_qty)
				inventory_location_order_quantity_detail[dynamic_key] = ret.responseJSON.order_qty;
			},
		});
	}
}

function get_vendors(ev) {
	get_order_quantity_by_item_and_location_id();
	new Ajax.Request('ajax/supplies/get_vendors/', {
		parameters : { 'item_id':$('items').value },
		onSuccess : function(ret) {
			var vendorsel = build_select('vendors','vendors',ret.responseJSON.vendors,$H({ 'data-price':'price','data-partnum':'part_num' }));
			$('vendors').replace(vendorsel);
			if (!ret.responseJSON.vendors || !ret.responseJSON.vendors.length) {
				vendorsel.insert(new Element('option', { 'value': '' }).update('--No Vendors Found--'));
				vendorsel.disable();
				am.$('#editItemButton').fadeIn();
				am.$('#qty_to_order').prop('disabled', true);
			}
			else{
				am.$('#editItemButton').hide();
				am.$('#qty_to_order').prop('disabled', false);
				am.$('#qty_to_order').focus();
			}

			valid_po_form();
		}
	});
}
function valid_po_form(){
	var invalid = 0;
	if(!$('location_1').value){
		invalid++;
	}
	if(!$('items').value){
		invalid++;
	}
	if(!$('vendors').value){
		invalid++;
	}
	if(am.$('#qty_to_order').val() < 0 || am.$('#qty_to_order').val() == ''){
		invalid++;
	}
	if(invalid == 0){
		am.$('#addpoorder').removeClass('am-btn--disabled').prop('disabled', false);
	}
	else{
		am.$('#addpoorder').addClass('am-btn--disabled').prop('disabled', true);
		
	}
}
function add_product(el) {
	if(!$('location_1').value || !$('items').value || !$('vendors').value)
	{ 
		if(!$('location_1').value){
			show_snackbar({
				message: 'Please select a valid Location',
				type: 'danger',
				timer: 3000,
			});
		}
		if(!$('items').value){
			show_snackbar({
				message: 'Please select a valid Item',
				type: 'danger',
				timer: 3000,
			});
		}
		if(!$('vendors').value){
			show_snackbar({
				message: 'Please select a valid Vendor',
				type: 'danger',
				timer: 3000,
			});
		}
		return;
	}
	var vendor_id = $F('vendors');
	if (!$('vendor_'+vendor_id)) {
		new Ajax.Request('ajax/supplies/get_vendor_info/',{
			parameters : { vendor_id : vendor_id, item_id : $F('items') },
			onSuccess : function(ret) {
				var vendor = vendor_template.evaluate({ "id":vendor_id,"name": ret.responseJSON.vendor_company_name,"email": ret.responseJSON.contact_email,"pname":ret.responseJSON.contact_name });
				$('pos').insert(vendor);
				sort_po();
				add_product(el);
				checkPOItems();
			},
			onFailure : function(ret) {
				return;
			}
		});
	}
	else {
		var il_id = $('items').options[$('items').selectedIndex].readAttribute('data-il_id');
		var vendor_sel = $('vendors').clone(true);
		vendor_sel.removeAttribute('id');
		vendor_sel.writeAttribute('data-item_id',$F('items'));
		vendor_sel.name = 'vendor['+il_id+']';
		vendor_sel.id = 'v'+new Date().getTime();
		vendor_sel.setValue($F('vendors'));
		vendor_sel.select('option')[vendor_sel.selectedIndex].writeAttribute('selected','selected');
		vendor_sel.writeAttribute('onchange','move_row(this)');
		var existing = $('pos').down('.il_'+il_id);
		if (!existing) {
			var new_el = new Element('tr').addClassName('il_'+il_id)
				.insert(new Element('td').update($('items').options[$('items').selectedIndex].innerHTML))
				.insert(new Element('td'))
				.insert(new Element('td').update(new Element('input',{ type: 'text', name:'qty['+il_id+']',style:'width: 4em',value:$F('qty_to_order') }).addClassName('text').addClassName('qty')
						.observe('change', function(ev) {
							recalculate_po_totals();
						})))
				.insert(new Element('td').update(vendor_sel))
				.insert(new Element('td').update(new Element('a',{ class: 'delete_link', href: 'javascript:void(0);', onclick: 'delRow($(this).up());return check_visible(this.up("tbody"))' })
					.update(new Element('i', { class: 'fa fa-trash' }))));
			//new_el.down('select').value = vendor_id;
			$('vendor_'+vendor_id).down('table tbody').insert(new_el);
			$('vendor_'+vendor_id).show();
			Effect.ScrollTo('vendor_'+vendor_id,{ offset:-50 });
			new Effect.Highlight(new_el, { duration: 3.0 });
		}
		else {
			Effect.ScrollTo(existing.up('fieldset'),{ offset:-50 });
			new Effect.Highlight(existing, { duration: 3.0 });
		}
		$('add_template').update(add_template.evaluate());
		recalculate_po_totals();
		checkPOItems();
	}
	show_required();
	
	return false;
}
function recalculate_po_totals() {
	$$('.vendor_po').each(function(v) {
		var total = 0; 
		v.select('option:selected').each(function(el) { 
			total+=(parseInt($F(el.up('tr').down('.qty')) || 0) * parseFloat(el.getAttribute('data-price')?el.getAttribute('data-price'):0));} 
		); 
		if (v.down(".total")) {
      v.down(".total").update(number_format(total, 2));
    }
	});
}
//DEV-1020
function order_status_not_shipped(id){
	// DEV-13144: this lookup runs twice per pick - once from the Order field's change
	// event (with whatever was typed BEFORE the pick, which can be a different order)
	// and once from time_tracking_job_update with the order that was actually picked.
	// The two responses can land in either order, so a typed prefix's status could
	// overwrite the picked order's "shipped" and the shipped warning was skipped.
	// Only the most recent request may write #order_status.
	if(id && typeof id === 'object' && 'value' in id){
		var m = String(id.value).match(/^\s*#?(\d+)/);
		if(!m) return; // nothing numeric to look up
		id = m[1];
	}
	if(!id) return;
	var seq = order_status_not_shipped.seq = (order_status_not_shipped.seq || 0) + 1;
	new Ajax.Request('ajax/', {
		parameters : {
			'table' : 'status_shipped_check',
			'order_id' : id
		},
		onSuccess : function(ret){
			if(seq !== order_status_not_shipped.seq) return; // superseded by a newer lookup
			$('order_status').value = ret.responseJSON;
		}
	});
}

function listen_autocomplete_orders(t){
	// Typing invalidates any earlier pick (the field's onkeyup also blanks
	// track_order_id). The flag is set back to true by time_tracking_job_update when an
	// order is actually selected from the dropdown or a tab row (DEV-13144).
	t.setAttribute('data-was_clicked', 'false');
}

